/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location */

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Check, History } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import moment from 'moment';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import BankDetail from './BankDetail';
import TermsAndCondition from './TermsAndConditions';

import Fab from '@material-ui/core/Fab';
import { Alert } from '@material-ui/lab';
import { Button, Divider, Result } from 'antd';
import { withTranslation } from 'react-i18next';

import Session from '../../Service/Session';
import { profileStyle } from '../Common/CommonStyle';
import MobileFooter from '../Common/Profile/MobileFooter';
import ExpandIcon from '../Common/Profile/SvgIcon/ExpandIcon';

import ReactLoaderSpinner from 'react-loader-spinner';
import BuxService from '../../Service/BuxService';
import UserService from '../../Service/UserService';
import LanguageSelector from '../Home/Base/Nav/LanguageSelector';
import Base from './BaseProfile/Base';
import GreenSection from './BaseProfile/GreenSection';
import CashOut from './CashOut';
import CashoutBankOptions from './CashOut/CashoutBankOptions';
import ChangePassword from './ChangePassword';
import CreateBankAccount from './CreateBankAccount';
import EditContactDetail from './EditContactDetails';
import EditProfile from './EditProfile';
import UploadId from './IdUpload/UploadId';
import SubmitKYC from './SubmitKYC';
import TopupForm from './TopupDetails';
import TransactionHistory from './TransactionHistory';

const APP_STRING = window.AppStrings;

class Profile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_openEditScreen: '',
			_error: '',
			_name: '',
			_isLoading: false,
			_openScreen: this.props.isOpenDwollaPlaid ? 'DWOLLA_PLAID' : '',
			_contactDetailMode: 'Email',
			expanded: 'panel1',
			balance: 0,
			users: {},
			banks: [],
			selectedBank: { bank: '', account_number: '', bank_account_id: '' }
		};
	}

	closeChangePasswordAccordion = () => {
		this.setState({
			expanded: 'panel1'
		});
	};

	handleExpanded = (pannel, _event, newExpand) => {
		this.setState({
			expanded: newExpand ? pannel : false
		});
	};

	openTermsAndConditionScreen = () => {
		this.setState({
			_openScreen: 'TERMS_CONDITIONS'
		});
	};

	openBankScreen = () => {
		this.setState({
			_openScreen: 'BANK_DETAILS'
		});
	};

	backToProfileScreen = () => {
		this.setState({ _openScreen: '' });
		// this.getKycStatus();
	};

	openEditScreen = screen => {
		this.setState({
			_openScreen: 'EDIT_PROFILE',
			_openEditScreen: screen
		});
	};

	redirectTodwollaPlaid = () => {
		this.setState({
			_openScreen: 'DWOLLA_PLAID'
		});
	};

	redirectToTopUp = () => {
		this.setState({
			_openScreen: 'TOPUP_DETAILS'
		});
	};

	redirectToKyc = () => {
		this.setState({
			_openScreen: 'KYC_SUBMIT'
		});
	};

	redirectToAddBankAccount = () => {
		this.setState({
			_openScreen: 'CREATE_BANK_ACCOUNT'
		});
	};

	redirectToCashOut = () => {
		this.setState({
			_openScreen: 'CASH_OUT'
		});
	};

	openContactDetailScreen = mode => {
		this.setState({
			_openScreen: 'EDIT_CONTACT_DETAIl',
			_contactDetailMode: mode
		});
	};

	openEditUploadId = () => {
		this.setState({
			_openScreen: 'EDIT_UPLOAD'
		});
	};

	toHome = () => {
		this.props.openScreen('HOME');
	};

	toProfile = () => {
		this.props.openScreen('PROFILE');
	};

	toDashBoard = () => {
		this.props.openScreen('LOAN_LIST');
	};

	refreshToken = async () => {
		await BuxService.buxAuthToken();
	};

	componentDidMount() {
		if (this.props.error) {
			this.setState({ _error: this.props.error, _isLoading: false });
		} else {
			this.refreshToken();
			this.updateKycDB();
		}
	}

	updateKycDB = async () => {
		this.setState({ _isLoading: true });
		try {
			const users = await UserService.getKycStatus({
				id: this.props.currentUser.profile.id,
				action: 'SUBMIT_KYC'
			});

			if (users) {
				const banks = [users?.item?.bank, users?.item?.bank_2, users?.item?.bank_3];

				this.setState({ users: users?.item || {}, _isLoading: false });

				this.setState({
					banks: banks.map(v => ({ bank: v, isClicked: false }))
				});
			}
		} catch (error) {
			this.setState({ _error: error.message, _isLoading: false });
		}
	};

	formatDate(date) {
		return moment(date).locale('en').format('MMM DD YYYY');
	}

	handleCashoutChooseOption = (item, index) => {
		this.setState(prevState => {
			const updatedBanks = prevState.banks.map((v, i) => ({
				...v,
				isClicked: i == index
			}));
			return { ...prevState, banks: updatedBanks };
		});

		this.setState({
			selectedBank: {
				bank: item.bank,
				account_number: item.account_number,
				bank_account_id: item.bank_account_id
			}
		});
	};

	render() {
		// NOSONAR

		const { classes } = this.props;
		const { t } = this.props;

		const currentUser = this.props.currentUser.profile;

		const uploadedId = Session.get(APP_STRING.UPLOAD_ID);

		const usable_balance = +this.state?.users?.usable_balance || 0;
		const wallet_balance = +this.state?.users?.wallet_balance || 0;
		const pending_balance = +this.state?.users?.wallet_balance - +this.state?.users?.usable_balance || 0;

		const cashoutButtonsDesign = [
			{
				bgColor: 'rgb(37, 183, 141)',
				border: '#25B78D'
			},
			{
				bgColor: 'rgb(255, 198, 60)',
				border: '#FFC63C'
			},
			{
				bgColor: 'rgb(118, 195, 237)',
				border: '#76C3ED'
			}
		];

		// store here the bank accounts of the user from the database
		const bankAccountsForCashout = [
			{
				bank: this.state.users?.bank,
				account_number: this.state.users?.account_number,
				bank_account_id: this.state.users?.bank_account_id,
				bgColor: this.state.users?.bank ? cashoutButtonsDesign[0].bgColor : 'rgb(237, 237, 237)',
				opac: this.state.users?.bank ? '0.19' : '1',
				inverted: false,
				border: cashoutButtonsDesign[0].border,
				type: 'cashoutBankOptions',
				styleText: { fontSize: '13px' }
			},
			{
				bank: this.state.users?.bank_2,
				account_number: this.state.users?.account_number_2,
				bank_account_id: this.state.users?.bank_account_id_2,
				bgColor: this.state.users?.bank ? cashoutButtonsDesign[1].bgColor : 'rgb(237, 237, 237)',
				opac: this.state.users?.bank ? '0.19' : '1',
				inverted: false,
				border: cashoutButtonsDesign[1].border,
				type: 'cashoutBankOptions',
				styleText: { fontSize: '13px' }
			},

			{
				bank: this.state.users?.bank_3,
				account_number: this.state.users?.account_number_3,
				bank_account_id: this.state.users?.bank_account_id_3,
				bgColor: this.state.users?.bank ? cashoutButtonsDesign[2].bgColor : 'rgb(237, 237, 237)',
				opac: this.state.users?.bank ? '0.19' : '1',
				inverted: false,
				border: cashoutButtonsDesign[2].border,
				type: 'cashoutBankOptions',
				styleText: { fontSize: '13px' }
			}
		];

		if (this.state._openScreen === 'BANK_DETAILS') {
			return (
				<BankDetail
					accounts={currentUser.accounts}
					closeBankScreen={this.backToProfileScreen}
					currentUser={this.props.currentUser}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
				/>
			);
		} else if (this.state._openScreen === 'DWOLLA_PLAID') {
			return (
				<>
					<SubmitKYC
						currentUser={this.props.currentUser}
						onBack={this.backToProfileScreen}
						onClose={this.backToProfileScreen}
						openScreen={this.props.openScreen}
						setCurrentUser={this.props.setCurrentUser}
						supportedStates={this.props.supportedStates}
						forKYC={false}
					/>

					{/* <DwollaPlaid
						currentUser={this.props.currentUser}
						onBack={this.backToProfileScreen}
						onClose={this.backToProfileScreen}
						openScreen={this.props.openScreen}
						setCurrentUser={this.props.setCurrentUser}
						supportedStates={this.props.supportedStates}
					/> */}
				</>
			);
		} else if (this.state._openScreen === 'TERMS_CONDITIONS') {
			return (
				<TermsAndCondition
					currentUser={this.props.currentUser.profile}
					handleBack={this.backToProfileScreen}
					handleContinue={this.redirectTodwollaPlaid}
				/>
			);
		} else if (this.state._openScreen === 'EDIT_PROFILE') {
			return (
				<EditProfile
					closeProfileScreen={this.backToProfileScreen}
					openScreen={this.state._openEditScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
					user={this.props.currentUser.profile}
				/>
			);
		} else if (this.state._openScreen === 'TOPUP_DETAILS') {
			return (
				<TopupForm
					closeProfileScreen={this.backToProfileScreen}
					currentUser={this.props.currentUser.profile}
					openScreen={this.state._openEditScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
					toHome={this.toProfile}
					user={this.props.currentUser.profile}
				/>
			);
		} else if (this.state._openScreen === 'EDIT_CONTACT_DETAIl') {
			return (
				<EditContactDetail
					contactDetailMode={this.state._contactDetailMode}
					currentUser={this.props.currentUser.profile}
					onBack={this.backToProfileScreen}
					setCurrentUser={this.props.setCurrentUser}
				/>
			);
		} else if (this.state._openScreen === 'EDIT_UPLOAD') {
			return <UploadId currentUser={this.props.currentUser.profile} onBack={this.backToProfileScreen} />;
		} else if (this.state._openScreen === 'CREATE_BANK_ACCOUNT') {
			return (
				<CreateBankAccount
					closeProfileScreen={this.backToProfileScreen}
					currentUser={this.props.currentUser.profile}
					onBack={this.backToProfileScreen}
					setCurrentUser={this.props.setCurrentUser}
					toHome={this.toProfile}
					user={this.props.currentUser.profile}
				/>
			);
		} else if (this.state._openScreen === 'CASH_OUT') {
			return (
				<CashOut
					closeProfileScreen={this.backToProfileScreen}
					currentUser={this.props.currentUser.profile}
					onBack={this.backToProfileScreen}
					setCurrentUser={this.props.setCurrentUser}
					user={this.props.currentUser.profile}
					selectedBank={this.state.selectedBank}
				/>
			);
		} else if (this.state._openScreen === 'KYC_SUBMIT') {
			return (
				<SubmitKYC
					currentUser={this.props.currentUser}
					onBack={this.backToProfileScreen}
					onClose={this.backToProfileScreen}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
					forKYC={true}
				/>
			);
		} else {
			return (
				<Base classes={classes}>
					<div className="mobile_wrapper">
						<GreenSection
							error={this.state._error}
							loading={this.state._isLoading}
							kycStatus={this.state?.users}
							classes={classes}
							currentUser={this.props.currentUser.profile}
							redirectToKyc={this.redirectToKyc}>
							<p className="bold-important">{currentUser.phone}</p>
						</GreenSection>
					</div>

					<Grid alignItems="center" className="mobile_grid_container" item justify="center" sm={12} xs={12}>
						<Paper className="mobile_paper">
							<List className={classes.root}>
								<Accordion
									defaultExpanded
									expanded={this.state.expanded === 'panel1'}
									id="kyc"
									onChange={(e, n) => {
										this.handleExpanded('panel1', e, n);
									}}>
									<AccordionSummary
										aria-controls="panel4d-content"
										className="mobile_accordion_list_bg"
										// aria-label="Expand"
										expandIcon={<ExpandIcon />}
										id="panel3d-header">
										<Typography variant="h5"> {t('label.bank_details')} </Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Grid item sm={12} xs={12}>
											{this.state._error ? null : this.state._isLoading ? null : (
												<ListItem className="wallet_item_container">
													<div
														style={{
															fontSize: '14px',
															fontWeight: 'bold',
															alignSelf: 'start',
															marginBottom: '5px'
														}}>
														{t('profile.dwolla_balance')}
													</div>
													<div className="wallet-balance-card-container">
														<div
															className="wallet-balance-card"
															style={{
																background: '#27B88D52',
																border: '2px solid #27B88D'
															}}>
															<div className="wallet-balance">
																{usable_balance.toLocaleString('en-PH', {
																	style: 'currency',
																	currency: 'PHP'
																})}
															</div>
															<div
																style={{
																	display: 'flex',
																	justifyContent: 'center',
																	columnGap: '2px'
																}}>
																<Check
																	style={{
																		fontSize: '20px'
																	}}
																/>
																<div>Available</div>
															</div>
															<p>Cleared funds available for pay out</p>
														</div>
														<div
															className="wallet-balance-card"
															style={{
																background: '#FFC63C52',
																border: '2px solid #FFC63C'
															}}>
															<div
																style={{
																	display: 'flex',
																	justifyContent: 'space-between'
																}}>
																<div>
																	<History /> <span>Pending</span>
																</div>
																<div
																	style={{
																		fontSize: '20px',
																		fontWeight: 'bold'
																	}}>
																	{pending_balance.toLocaleString('en-PH', {
																		style: 'currency',
																		currency: 'PHP'
																	})}
																</div>
															</div>
															<div
																style={{
																	fontSize: '12px',
																	color: 'rgb(172, 170, 166)'
																}}>
																<span
																	style={{
																		textTransform: 'uppercase',
																		marginRight: '3px'
																	}}>
																	Top-up in progress
																</span>
																<span data-for="top-up" data-tip id="top-up">
																	<InfoIcon
																		color="disabled"
																		style={{
																			cursor: 'pointer'
																		}}
																	/>
																</span>
																<ReactTooltip
																	aria-haspopup="true"
																	className="customTheme"
																	overridePosition={(
																		{ left, top },
																		currentEvent,
																		currentTarget,
																		node
																	) => {
																		const d = document.documentElement;
																		left = Math.min(
																			d.clientWidth - node.clientWidth,
																			left
																		);
																		top = Math.min(
																			d.clientHeight - node.clientHeight,
																			top
																		);
																		left = Math.max(0, left);
																		top = Math.max(0, top);
																		return { top, left };
																	}}
																	effect="solid"
																	id="top-up"
																	place="top"
																	role="top-up">
																	Processing of Top-up Amount is 1 Business Day
																</ReactTooltip>
															</div>
															<p
																style={{
																	textAlign: 'start'
																}}>
																Funds will be available after 24 hours or one
																&#40;1&#41; business day.
															</p>
														</div>
														<div
															className="wallet-balance-card"
															style={{
																background: '#76c4ee52',
																border: '2px solid #76c4ee'
															}}>
															<div
																style={{
																	fontSize: '20px'
																}}>
																{wallet_balance.toLocaleString('en-PH', {
																	style: 'currency',
																	currency: 'PHP'
																})}
															</div>
															<div>
																Total Balance{' '}
																<span
																	data-for="total-balance"
																	data-tip
																	id="total-balance">
																	<InfoIcon
																		color="disabled"
																		style={{
																			cursor: 'pointer'
																		}}
																	/>
																</span>
																<ReactTooltip
																	aria-haspopup="true"
																	className="customTheme"
																	overridePosition={(
																		{ left, top },
																		currentEvent,
																		currentTarget,
																		node
																	) => {
																		const d = document.documentElement;
																		left = Math.min(
																			d.clientWidth - node.clientWidth,
																			left
																		);
																		top = Math.min(
																			d.clientHeight - node.clientHeight,
																			top
																		);
																		left = Math.max(0, left);
																		top = Math.max(0, top);
																		return { top, left };
																	}}
																	effect="solid"
																	id="total-balance"
																	place="top"
																	role="total-balance">
																	Available Funds for Transactions
																</ReactTooltip>
															</div>
														</div>
													</div>

													{!this.state.users?.wallet_connected ? (
														<Tooltip arrow title="Create Wallet">
															<AddIcon
																className={classes.cursor}
																onClick={this.redirectTodwollaPlaid}
																style={{
																	fontSize: '30px'
																}}
															/>
														</Tooltip>
													) : (
														<Fab
															aria-label="add"
															className={classes.submit}
															color="primary"
															onClick={this.redirectToTopUp}
															size="small"
															type="submit"
															variant="extended">
															TOP UP
														</Fab>
													)}
													<Divider className="mobile_divider" />
												</ListItem>
											)}

											{/* KYC */}

											{/* {(currentUser.wallet_connected && !currentUser.kyc) ||
												(currentUser.wallet_connected &&
													currentUser.kyc &&
													!this.state.kycStatus.approved &&
													this.state.kycStatus.remarks && ( */}

											{this.state._error ? (
												<Result
													status="error"
													title="Server Error"
													subTitle="Sorry, something went wrong. Please try again later"
													extra={
														<Button
															type="primary"
															onClick={() => {
																localStorage.removeItem('error');

																window.location.reload();
															}}>
															Try Reload The Page
														</Button>
													}
												/>
											) : this.state._isLoading ? (
												<ReactLoaderSpinner />
											) : (
												<ListItem className="wallet_item_container">
													<ListItemText
														className="wallet_item_content"
														primary={[
															t('profile.bux_kyc'),
															<br />,
															<span className="rq_text">{t('profile.bux_kyc_note')}</span>
														]}
														secondary={
															!this.state.users?.wallet_connected ? (
																<span style={{ color: 'red' }}>Wallet Required!</span>
															) : this.state.users?.kyc_resubmission_date &&
															  this.state.users?.kyc_status === 'Rejected' ? (
																'Pending'
															) : (
																this.state.users?.kyc_status
															)
														}
													/>

													{this.state.users?.kyc_status === 'Rejected' &&
													!this.state.users?.kyc_resubmission_date ? (
														this.state.users?.reason_of_kyc_rejection.includes(
															'Must specify a valid sub wallet'
														) ? null : (
															<Alert severity="error">
																{this.state.users?.reason_of_kyc_rejection}
															</Alert>
														)
													) : this.state.users?.kyc_resubmission_date &&
													  this.state.users?.kyc_status === 'Rejected' ? (
														<Alert severity="info">
															<p className="info">
																Important Note: Processing of re-submitted documents may
																take 1-2 business days. The result will be sent to you
																via email.
															</p>
														</Alert>
													) : null}

													<Fab
														aria-label="add"
														className={classes.submit}
														color="primary"
														disabled={
															this.state.users?.kyc_status === 'Approved' ||
															this.state.users?.kyc_status === 'Pending' ||
															!this.state.users?.wallet_connected ||
															(this.state.users?.kyc_resubmission_date &&
																this.state.users?.kyc_status === 'Rejected')
														}
														onClick={this.redirectToKyc}
														size="small"
														type="submit"
														variant="extended">
														{this.state.users?.kyc_status === 'Not Yet Submitted'
															? 'SUBMIT'
															: this.state.users?.kyc_status === 'Rejected' &&
															  this.state.users?.submission_date &&
															  this.state.users?.reason_of_kyc_rejection
															? 'SUBMIT AGAIN'
															: 'SUBMITTED'}
													</Fab>

													<Divider className="mobile_divider" />
												</ListItem>
											)}

											{/* BANK ACCOUNT */}

											{this.state.users?.wallet_connected &&
												this.state.users?.kyc_status === 'Not Yet Submitted' && (
													<ListItem className="wallet_item_container">
														<ListItemText
															className="wallet_item_content"
															primary={[
																t('profile.dwolla_cash_out'),
																<br />,

																<span className="rq_text">
																	{t('profile.dwolla_cash_out_unavailable')}
																</span>
															]}
															secondary="Unavailable"
														/>
														<Fab
															aria-label="add"
															className={classes.submit}
															color="primary"
															disabled
															onClick={this.redirectToCashOut}
															size="small"
															type="submit"
															variant="extended">
															Cash Out
														</Fab>
													</ListItem>
												)}

											{this.state.users?.wallet_connected &&
												this.state.users?.kyc_status === 'Pending' && (
													<ListItem className="wallet_item_container">
														<ListItemText
															className="wallet_item_content"
															primary={t('profile.dwolla_cash_out')}
															secondary="KYC is being processed"
														/>
													</ListItem>
												)}
											{/* cashout */}
											{this.state.users?.wallet_connected &&
												this.state.users?.kyc_status === 'Approved' &&
												this.state.users?.bank_account_id && (
													<ListItem className="wallet_item_container">
														<ListItemText
															className="wallet_item_content"
															primary={[
																t('profile.dwolla_cash_out'),
																<br />,
																<span
																	style={{
																		marginTop: 6,
																		width: '60vw !important',
																		whiteSpace: 'nowrap'
																	}}
																	className="rq_text">
																	Choose your preferred account
																</span>
															]}
															// secondary={`${this.state.users?.bank} (${this.state.users?.account_number})`}
														/>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																alignItems: 'center',
																justifyContent: 'center'
															}}>
															<CashoutBankOptions
																bankAccountsForCashout={bankAccountsForCashout}
																currentUser={this.props.currentUser.profile}
																banks={this.state.banks}
																setCurrentUser={this.props.setCurrentUser}
																handleCashoutChooseOption={
																	this.handleCashoutChooseOption
																}
																classes={classes}
															/>
															<Fab
																disabled={!this.state.banks.some(v => v.isClicked)}
																aria-label="add"
																className={classes.submit}
																color="primary"
																onClick={this.redirectToCashOut}
																size="small"
																style={{ margin: 'auto', marginTop: '24px' }}
																type="submit"
																variant="extended">
																Cash Out
															</Fab>
															{/* <Fab
																aria-label="add"
																className={classes.submit}
																color="primary"
																onClick={() => {
																	this.props.setCurrentUser({
																		...this.props.currentUser,
																		profile: {
																			...this.props.currentUser.profile,
																			bank_account_id: null,
																			bank: null,
																			account_number: null
																		}
																	});
																}}
																size="small"
																style={{ marginLeft: '10px' }}
																type="submit"
																variant="extended">
																Remove
															</Fab> */}
														</div>
													</ListItem>
												)}
											{this.state.users?.wallet_connected &&
												this.state.users?.kyc_status === 'Approved' &&
												!this.state.users?.bank_account_id && (
													<ListItem className="wallet_item_container">
														<ListItemText
															className="wallet_item_content"
															primary={t('profile.dwolla_bank_account')}
															secondary="No Bank Account"
														/>
														<Fab
															aria-label="add"
															className={classes.submit}
															color="primary"
															onClick={this.redirectToAddBankAccount}
															size="small"
															type="submit"
															variant="extended">
															Add Account
														</Fab>
													</ListItem>
												)}
										</Grid>
									</AccordionDetails>
								</Accordion>
								{/* transaction history */}
								<Accordion
									expanded={this.state.expanded === 'panel2'}
									onChange={(e, n) => {
										this.handleExpanded('panel2', e, n);
									}}>
									<AccordionSummary
										aria-controls="panel2d-content"
										className="mobile_accordion_list_bg"
										expandIcon={<ExpandIcon />}
										id="panel2d-header">
										<Typography variant="h5"> Transaction History </Typography>
									</AccordionSummary>
									<AccordionDetails className="transaction_accordion">
										<TransactionHistory />
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={this.state.expanded === 'panel3'}
									onChange={(e, n) => {
										this.handleExpanded('panel3', e, n);
									}}>
									<AccordionSummary
										aria-controls="panel1d-content"
										className="mobile_accordion_list_bg"
										expandIcon={<ExpandIcon />}
										id="panel1d-header">
										<Typography variant="h5"> {t('profile.personal_info')} </Typography>
									</AccordionSummary>

									<AccordionDetails>
										<Grid className="mobile_list_grid" item sm={12} xs={12}>
											<ListItem>
												<ListItemText
													primary={t('label.birth_date')}
													secondary={
														currentUser.dob
															? new Date(currentUser.dob).toLocaleDateString()
															: ''
													}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary={t('label.address')}
													secondary={
														currentUser.address
															? currentUser.address
																	.trim()
																	.split(' ')
																	.map(m => m[0]?.toUpperCase() + m.slice(1))
																	.join(' ')
															: ''
													}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary={t('label.city')}
													secondary={
														currentUser.city
															? currentUser.city
																	.trim()
																	.split(' ')
																	.map(m => m[0]?.toUpperCase() + m.slice(1))
																	.join(' ')
															: ''
													}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary={t('label.state')}
													secondary={
														currentUser.province
															? currentUser.province
																	.trim()
																	.split(' ')
																	.map(m => m[0]?.toUpperCase() + m.slice(1))
																	.join(' ')
															: currentUser.state_name || ''
													}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													primary={t('label.postal_code')}
													secondary={
														currentUser.postal_code ? currentUser.postal_code.trim() : ''
													}
												/>
											</ListItem>

											<Tooltip arrow title={t('profile.edit_address_info')}>
												<Button
													className="btn-orange"
													onClick={() => {
														this.openEditScreen('');
													}}
													size="large"
													type="primary">
													Edit Address
												</Button>
											</Tooltip>
											<Divider className="mobile_divider" />

											<ListItem>
												<ListItemText
													alignitems="left"
													id="overflow"
													primary={t('label.phone')}
													secondary={currentUser.phone || ''}
												/>
											</ListItem>
											<ListItem>
												<ListItemText
													id="overflow"
													primary={t('label.email')}
													secondary={currentUser.email || ''}
												/>
											</ListItem>

											<Divider className="mobile_divider nomargin_vertical_top" />

											{Array.isArray(uploadedId.data.data) &&
												uploadedId.data.data.map(item => {
													return (
														<ListItem key={item.id}>
															<ListItemText
																id="overflow"
																primary={
																	item.id === 'frontId'
																		? 'Front ID'
																		: item.id === 'backId'
																		? 'Back ID'
																		: 'Selfie'
																}
																secondary={item.value ? 'Submitted' : ''}
															/>
														</ListItem>
													);
												})}

											<ListItem>
												<ListItemText
													id="overflow"
													primary="Type ID"
													secondary={JSON.parse(currentUser?.id_type)?.label || 'N/A'}
												/>
											</ListItem>

											{!Array.isArray(uploadedId.data.data) && (
												<ListItem>
													<ListItemAvatar>
														<Avatar>
															<MailOutlineIcon className={classes.IconColor} />
														</Avatar>
													</ListItemAvatar>
													<ListItemText
														id="overflow"
														primary="Uploaded ID"
														secondary={uploadedId.data.data || ''}
													/>
													<Tooltip arrow title="edit ID">
														<EditIcon
															onClick={() => {
																this.openEditUploadId();
															}}
														/>
													</Tooltip>
												</ListItem>
											)}
										</Grid>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={this.state.expanded === 'panel4'}
									onChange={(e, n) => {
										this.handleExpanded('panel4', e, n);
									}}>
									<AccordionSummary
										aria-controls="panel2d-content"
										className="mobile_accordion_list_bg"
										expandIcon={<ExpandIcon />}
										id="panel2d-header">
										<Typography variant="h5"> {t('label.password')} </Typography>
									</AccordionSummary>
									<AccordionDetails>
										{this.state.expanded === 'panel4' ? (
											<ChangePassword onBack={this.closeChangePasswordAccordion} />
										) : (
											''
										)}
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={this.state.expanded === 'panel5'}
									onChange={(e, n) => {
										this.handleExpanded('panel5', e, n);
									}}>
									<AccordionSummary
										aria-controls="panel3d-content"
										className="mobile_accordion_list_bg"
										expandIcon={<ExpandIcon />}
										id="panel2d-header">
										<Typography variant="h5"> {t('label.change_language')} </Typography>
									</AccordionSummary>
									<AccordionDetails>
										{this.state.expanded === 'panel5' ? (
											<>
												<LanguageSelector
													currentUser={this.props.currentUser}
													fromProfileScreen
													setCurrentUser={this.props.setCurrentUser}
												/>
												<Typography
													style={{ marginLeft: '10px', fontWeight: 'Bold' }}
													variant="h6"
												/>
											</>
										) : (
											''
										)}
									</AccordionDetails>
								</Accordion>
							</List>
						</Paper>
					</Grid>

					<MobileFooter className="main_footer" onClick={this.toDashBoard} />
				</Base>
			);
		}
	}
}

export default withStyles(profileStyle)(withTranslation()(Profile));
